<template>
  <sp-button
    v-if="cancellable"
    slot="actions"
    variant="outlined"
    :data-testid="TestId.directoryPdf.cancel"
    @click="emit('reset')"
  >
    {{ t("cancel_label") }}
  </sp-button>

  <sp-button
    v-if="idle"
    slot="actions"
    color="primary"
    :disabled="!consent"
    :data-testid="TestId.directoryPdf.submit"
    @click="emit('submit')"
  >
    {{ t("submit_label") }}
  </sp-button>
  <sp-button v-else-if="generating" slot="actions" color="primary" disabled>
    {{ t("generating_label") }}
  </sp-button>
  <sp-button
    v-else-if="complete"
    slot="actions"
    variant="outlined"
    :data-testid="TestId.directoryPdf.startOver"
    @click="emit('reset')"
  >
    {{ t("start_over_label") }}
  </sp-button>
  <sp-button v-else slot="actions" color="primary" :data-testid="TestId.directoryPdf.retry" @click="emit('retry')">
    {{ t("retry_label") }}
  </sp-button>
</template>

<script setup>
import { computed } from "vue";
import { TestId } from "#/test-ids";
import { t } from "#ce/apps/SpDirectoryPdfExport/i18n";
import { useDirectoryPdfExportStore } from "#ce/apps/SpDirectoryPdfExport/store/export";

const emit = defineEmits(["submit", "reset", "retry"]);

const { idle, generating, complete, failed, consent } = useDirectoryPdfExportStore();

const cancellable = computed(() => generating.value || failed.value);
</script>
